module.exports = __webpack_public_path__ + "lang/sk.json";


//////////////////
// WEBPACK FOOTER
// ./lang/sk.json
// module id = 119
// module chunks = 3